
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { ROUTE_NAMES } from "@/routes";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";

export default Vue.extend({
  data() {
    return {
      isLoading: false,
      headers: [
        { text: "Application Id", value: "id" },
        { text: "Applicant name", value: "fullName" },
        { text: "Business name", value: "businessName" },
        { text: "Date sent", value: "submittedDate" },
        { text: "Status", value: "status" },
        { text: "Assignee", value: "assignedTo" }
      ],
    };
  },
  computed: {
    pagination: {
      get() {
        return store.state.application.dataTables.myApplications.pagination;
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_MY_APPLICATIONS_PAGINATION),
          value
        );
      }
    },
    statusFilters: {
      get(): any {
        return (
          store.state.application.dataTables.myApplications.statusFilters ||
          this.applicationStatuses
        );
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(
            APPLICATION.MUTATIONS.SET_MY_APPLICATIONS_DATA_TABLE_STATUS_FILTERS
          ),
          value
        );
      }
    },
    applicationStatuses(): any {
      return this.$store.getters[
        APPLICATION.NS(APPLICATION.GETTERS.GET_MY_APPLICATIONS_STATUSES)
      ];
    },
    ...mapState({
      myApplications: (state: IRootState) =>
        state.application.myApplicationsList,
      totalApplications: (state: IRootState) =>
        state.application.myApplicationsListTotal
    }),
    route: () => ROUTE_NAMES.APPLICATION_DETAIL
  },
  methods: {
    async onSearch() {
      this.isLoading = true;

      await this.$store.dispatch(
        APPLICATION.NS(APPLICATION.ACTIONS.LOAD_MY_APPLICATION_LIST),
        {
          statuses: this.statusFilters,
          pagination: this.pagination
        }
      );

      this.isLoading = false;
    },
    async onStatusChange(statuses: any) {
      this.pagination.page = 1;
      await this.onSearch();
    },
    goToDetails(id: any) {
      this.$router.push({
        name: ROUTE_NAMES.APPLICATION_DETAIL,
        params: { id }
      });
    }
  }
});
